import { Box, Container, H2, Image, Section } from 'react-components';
import { useAllPrismicDocumentsByType } from '@prismicio/react';
import { motion } from 'framer-motion';
import React from 'react';
import styled from 'styled-components';

const StyledImage = styled(Image)`
  transition: filter 0.2s ease-in-out;
  filter: grayscale(1);

  &:hover {
    filter: grayscale(0);
  }
`;

export const Partners: React.FunctionComponent = () => {
  const [document] = useAllPrismicDocumentsByType('about_us');

  if (!document) {
    return null;
  }

  const [
    {
      data: { partners },
    },
  ] = document;

  return (
    <Section>
      <Container py={{ _: 4, sm: '6rem' }}>
        <H2>Our partners</H2>
        <Box
          mt={{ _: 4, sm: '6rem' }}
          display="grid"
          gridTemplateColumns={{ _: '1fr', sm: 'repeat(3, 1fr)' }}
          gridRowGap={4}
          gridColumnGap="10%"
        >
          {partners.map(({ logo }: any, i: number) => (
            <Box display="flex" justifyContent="center" key={i}>
              <StyledImage
                as={motion.img}
                whileHover={{
                  scale: 1.05,
                }}
                src={logo.url}
                width="100%"
                alt={logo.alt}
                maxWidth={{ _: 'min(100%, 15rem)', sm: '100%' }}
              />
            </Box>
          ))}
        </Box>
      </Container>
    </Section>
  );
};
